import angular from 'angular';
import ShowMoreLessController from './show-more-less.controller';
import template from "./show-more-less.html";
export default angular
    .module('ShowMoreLessModule', [])
    .component('showMoreLess', {
    template: template,
    bindings: {
        content: '<',
        gaAction: '<',
        gaCategory: '<'
    },
    controller: ShowMoreLessController
})
    .name;
//# sourceMappingURL=index.js.map